<tr
  class="main"
  tabindex="0"
  [ngClass]="{ 'rounded-bottom': !showDetails, 'tr-pointer': hasDetails }"
  (click)="toggleDetails()"
  (keydown.enter)="toggleDetails()">
  @for (column of columns(); track column; let isLast = $last) {
    <td>
      <div class="row">
        @if (item()[column.key] !== undefined && item()[column.key] !== null) {
          <p>{{ item()[column.key] }}</p>
        } @else {
          <mat-icon
            class="missing-value-icon"
            [matTooltip]="missingValueMessageKey() | translate">
            {{ missingValueIcon() }}
          </mat-icon>
        }

        @if (isLast && hasDetails) {
          <mat-icon
            class="toggle-indicator"
            [class.flipped]="showDetails">
            expand_more
          </mat-icon>
        }
      </div>
    </td>
  }
</tr>
@if (showDetails) {
  <tr
    class="details"
    animate.leave="leave">
    <td [attr.colspan]="columns().length">
      <div class="details-wrapper">
        <ng-content></ng-content>
      </div>
    </td>
  </tr>
}
<tr
  class="divider"
  aria-hidden="true"></tr>
